<template>
    <div class="nc-msg-event" :class="{ 'nc-msg-event--ai-transfer': isAiTransfer }">
        <div class="nc-msg-event__header">
            <span class="nc-msg-event__text">{{ eventText }}</span>
            <span class="nc-msg-event__time">{{ formattedTime }}</span>
        </div>
        <div
            v-if="isAiTransfer && contextText"
            class="nc-msg-event__context"
            v-html="contextText"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'NewChatMessageEvent',
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isAiTransfer() {
            return this.message.direction === 'transferred_from_ai'
        },
        eventText() {
            if (this.isAiTransfer) {
                return this.message.message?.text || ''
            }
            return this.message.message || ''
        },
        contextText() {
            return this.message.message?.context?.text || ''
        },
        formattedTime() {
            return this.message.date_created || ''
        },
    },
}
</script>

<style lang="scss">
@import '../../../../../../gulp-src/app/scss/_variables';

.nc-msg-event {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 4px 0;

    &__header {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
    }

    &__text {
        font-size: 12px;
        line-height: 16px;
        color: $global-gray;
        text-align: center;
    }

    &__time {
        flex: 0 0 auto;
        font-size: 11px;
        line-height: 14px;
        color: $global-gray;
        opacity: 0.7;
    }

    &__context {
        font-size: 11px;
        line-height: 16px;
        color: $global-gray;
        opacity: 0.85;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 6px;
        padding: 6px 10px;
        max-width: 420px;
        text-align: left;
        white-space: pre-line;
    }
}
</style>